import React from "react";
import { useNavigate } from "react-router-dom";
import "./BackButton.css";

/**
 * BackButton Component
 *
 * A subtle "Back to Operations" button that navigates to /operations.
 * Designed to sit unobtrusively near the top of any operations sub-page.
 *
 * @param {Object}  props
 * @param {string}  [props.label]  - Override the button label text
 * @param {string}  [props.to]     - Override the destination path (default: /operations)
 */
const BackButton = ({ label = "Operations", to = "/operations" }) => {
    const navigate = useNavigate();

    return (
        <button
            className="back-btn"
            onClick={() => navigate(to)}
            aria-label={`Back to ${label}`}
            title={`Back to ${label}`}
        >
            <svg
                className="back-btn__arrow"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <path
                    d="M10 3L5 8l5 5"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
            </svg>
            <span className="back-btn__label">{label}</span>
        </button>
    );
};

export default BackButton;
